import firebase from 'firebase/app'
import 'firebase/firestore'
// import { Logger } from '@/js/utils/Logger.js'


export default class CampaignManager {
    constructor() {
      this.CampaignIds = {
        FirstTimeFree : "FirstTimeFree",
      }
    }

    async getFirstTimeFreeData(){
      const FirstTimeFreeData = await this.firstTimeFreeData();
      if (!FirstTimeFreeData) {
        return null;
      }
      return new FirstTimeFree(FirstTimeFreeData);
    }

    async setFirstTimeFreeData(data){
      await firebase.firestore().collection("AcryProCampaign").add(data);
    }

    async getUserDoc(){
      return firebase.firestore().collection("AcryProCampaign").doc(firebase.auth().currentUser.uid).get();
    }

    // ユーザーのキャンペーン状況のドキュメントを取得
    async firstTimeFreeData(){
      const snapshot = await firebase.firestore().collection("AcryProCampaign").where("uid", "==", firebase.auth().currentUser.uid).where("type", "==", this.CampaignIds.FirstTimeFree).get();
      if( snapshot.empty ){
        return null;
      }else{
        return snapshot.docs[0].data();
      }
    }
}


class FirstTimeFree {
  constructor(data){
    this.uid = (data)?data.uid:"";
    this.orderId = (data)?data.orderId:"";
    this.data = (data)?data.data:"";
  }
}


export { CampaignManager, FirstTimeFree }